import React from "react";
import {RouteComponentProps} from "react-router";
import Page from "../../utils/Page";
import './ErrorPageView.scss'

export default class ErrorPageView extends React.Component<RouteComponentProps> {
  componentDidMount(): void {
    Page.setTitle('Ошибка');
  }

  render() {
    return <div className='error-page-view'>
      <h1>404 Страница не найдена</h1>
    </div>
  }
}